export const RADIUS = {
  small: 4,
  medium: 8,
  large: 16,
  xlarge: 24,
  xxlarge: 32,
  xxxlarge: 100,
};
